


















































import Vue from 'vue';
import getThemeTextColor from '../../utils/getThemeTextColor';
import SAction from '../SAction/SAction.vue';

/**
 * A wrapper around the `SDialog` component. Use when you want to dialog toggle to be an icon.
 * If you want a label alongside that icon, you're probably better off using SDialog and a
 * custom slot
 */
export default Vue.extend({
  name: 'SActionDialog',
  components: {
    SAction,
    SDialog: () => import('../SDialog/SDialog.vue'),
  },
  props: {
    /**
     * If the dialog should be open or not
     */
    value: {
      type: Boolean,
      required: false,
    },
    /**
     * @see src/components/SDialog/SDialog.vue#title
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Text to show next to the buttons icon
     */
    label: {
      type: String,
      required: false,
    },
    /**
     * @deprecated Doesn't do anything useful
     */
    labelColor: {
      type: String,
      required: false,
    },
    /**
     * Is used as the buttons icon to trigger opening the dialog
     * @see src/components/SDialog/SDialog.vue#icon
     */
    icon: {
      type: String,
      required: true,
    },
    /**
     * The tooltip text to show when hovering over the button
     */
    tooltip: {
      type: String,
      required: true,
    },
    /**
     * @see src/components/STooltip/STooltip.vue#color
     */
    tooltipColor: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/STooltip/STooltip.vue#simplePosition
     */
    tooltipSimple: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * If true will make the icon in the button smaller
     */
    small: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * Sets the color of the icon
     */
    iconColor: {
      type: String,
      required: false,
    },
    /**
     * @see src/components/SDialog/SDialog.vue#flush
     */
    flush: {
      type: Boolean,
      required: false,
    },
    /**
     * Is used to set the background color of the button
     */
    color: {
      type: String,
      required: false,
    },
    /**
     * @deprecated Not used for anything
     */
    dismiss: {
      type: Boolean,
      required: false,
      default: true,
    },
    /**
     * @see src/components/SDialog/SDialog.vue#width
     */
    width: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    tooltipTextColor(): string {
      return getThemeTextColor(this.getTooltipColor);
    },
    getTooltipColor(): any {
      return this.tooltipColor ? this.tooltipColor : 'primary';
    },
    getIconColor(): any {
      return this.iconColor ? this.iconColor : 'white';
    },
  },
  methods: {
    afterCloseDialog() {
      /**
       * An event which is triggered when the dialog is closed
       * @event dialogClosed
       * @type {null}
       */
      this.$emit('dialogClosed');

      /**
       * Is triggered when the dialog opens or closes. (true is open, false is closed)
       * @event input
       * @type {boolean}
       */
      this.$emit('input', false);
    },
    afterOpenDialog() {
      /**
       * An event which is triggered when the dialog is opened
       * @event dialogOpen
       * @type {true}
       */
      this.$emit('dialogOpen', true);
      this.$emit('input', true);
    },
  },
});
